import { createFromIconfontCN } from '@ant-design/icons'

export const IconFont = createFromIconfontCN({
  scriptUrl: require('@/assets/iconfont/iconfont.js'),
})
